module.exports = __webpack_public_path__ + "static/img/logo_WX.13998534.png";